import { axiosInstance } from "../../../../../Services";

export const updateCardDueDate = async (cardId, dueDate) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/${cardId}`,
        {
          due_date: dueDate,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  };

  // ProjectBoardServices/BoardModalAPI/LeftModalAPI/CardAPI.js

export const updateCardDescription = async (cardId, description) => {
  try {
    const res = await axiosInstance.put(
      `/mmhboard/cards/${cardId}`,
      {
        description: description,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (error) {
    throw error;
  }
};

  